import { VetPreferences, VetPreferredAreasOfPractice } from "@Roo/api/vet";
import { patchVet } from "@Roo/api/vet/patchVet";
import {
  LOOKING_TO_START_USING_ROO,
  TYPICAL_AVAILABILITY_OPTIONS,
  idToFieldMap,
} from "@Roo/constants/checkBoxConstants";

import { useRedirect } from "../Common/hooks/useRedirect";
import { useRegistrationContext } from "../Common/registrationContext";

export const useValidate = () => {
  const validate = (form: VetPreferences) => {
    const errors: {
      yearsOfPractice?: string;
      currentSituation?: string;
      preferredAreasOfPractice?: string;
      preferredProcedures?: string;
      lookingToStart?: string;
      typicalAvailableDays?: string;
      lookingToStartOpenResponse?: string;
      typicalAvailableDaysOpenResponse?: string;
    } = {};
    if (!!form.yearsOfPractice && form.yearsOfPractice < 0) {
      errors.yearsOfPractice = "Years of practice must be a positive number";
    }

    if (form.yearsOfPractice && typeof form.yearsOfPractice !== "number") {
      errors.yearsOfPractice = "Years of practice must be a number";
    }

    if (
      form.lookingToStart === LOOKING_TO_START_USING_ROO.OTHER &&
      !form.lookingToStartOpenResponse
    ) {
      errors.lookingToStartOpenResponse = "Details are required";
    }

    if (
      form.typicalAvailableDays.some(
        (option) => option.checked && option.label === TYPICAL_AVAILABILITY_OPTIONS[7].label
      ) &&
      !form.typicalAvailableDaysOpenResponse
    ) {
      errors.typicalAvailableDaysOpenResponse = "Details are required";
    }

    return errors;
  };
  return { validate };
};

export const useSave = () => {
  const { redirectToMeetRooRep } = useRedirect();
  const { registrationContext, setRegistrationContext } = useRegistrationContext();
  const { userId, entityId } = registrationContext;

  const save = async (form: VetPreferences): Promise<void> => {
    setRegistrationContext({
      registrationContext: {
        ...registrationContext,
        ...form,
      },
    });

    const vetPreferredAreasOfPractice: VetPreferredAreasOfPractice =
      form.preferredAreasOfPractice.reduce((acc, curr) => {
        const key = idToFieldMap[Number(curr.id)];
        if (key) {
          acc[key] = !!curr.checked;
        }
        return acc;
      }, {} as VetPreferredAreasOfPractice);

    const typicalAvailableDays = form.typicalAvailableDays
      .filter((option) => option.checked)
      .map((checkedOption) => checkedOption.id);

    const vetData: any = {
      userId: userId,
      vetId: entityId,
      preferredProcedures: form.preferredProcedures
        .filter((vp) => vp.checked)
        .map((vp) => Number(vp.id)),
      preferredAreasOfPractice: true,
      lookingToStart: form.lookingToStart,
      currentSituation: form.currentSituation,
      typicalAvailableDays,
      typicalAvailableDaysOpenResponse: form.typicalAvailableDaysOpenResponse,
      lookingToStartOpenResponse: form.lookingToStartOpenResponse,
      ...vetPreferredAreasOfPractice,
    };
    // yearsOfPractice is potentially NaN because we read the input as event.target.valueAsNumber
    // empty strings => NaN
    if (form.yearsOfPractice && !isNaN(form.yearsOfPractice)) {
      vetData.yearsOfPractice = form.yearsOfPractice;
    }

    await patchVet(vetData);

    redirectToMeetRooRep();
  };
  return { save };
};
